// useCargar — carga asíncrona con estado { datos, cargando, error } y recarga manual.
// fn debe devolver una promesa (o null si aún no hay qué cargar); se vuelve a
// ejecutar cuando cambian las dependencias o se llama a recargar().

import { useEffect, useState } from 'react';

export default function useCargar(fn, deps, inicial = null) {
  const [estado, setEstado] = useState({ datos: inicial, cargando: true, error: '' });
  const [n, setN] = useState(0);

  useEffect(() => {
    let vivo = true;
    setEstado((e) => ({ ...e, cargando: true, error: '' }));
    Promise.resolve()
      .then(fn)
      .then((d) => vivo && setEstado({ datos: d ?? inicial, cargando: false, error: '' }))
      .catch((e) => vivo && setEstado({ datos: inicial, cargando: false, error: e?.message || 'No se pudieron cargar los datos.' }));
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, n]);

  return { ...estado, recargar: () => setN((x) => x + 1) };
}
